import React, { FC } from 'react';
import { currentDay, getFotmattedDateCreated } from 'utils/date';
import { ReactComponent as IconSvg } from './img/icon.svg';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconError } from 'assets/img/error.svg';
import styles from './PaymentsItem.module.scss';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import { BeneficiariesTabBtn } from 'ui/BeneficiariesTabBtn';
import { AppTooltip } from 'ui/AppTooltip';

interface PaymentsItemTypes {
  payment: any;
}

export const PaymentsItem: FC<PaymentsItemTypes> = ({ payment }) => {
  const lengthType = 35;
  const isOverflowing = payment.type.length > lengthType;
  const typeSlice = isOverflowing
    ? `${payment.type.slice(0, lengthType)}...`
    : payment.type;

  return (
    <div className={styles.root}>
      <div>
        <p className={styles.root_title}>{payment.id}</p>
        <p className={styles.root_subTitle}>{currentDay(payment.tochka_created_at)}</p>
      </div>
      <div style={{ position: 'relative' }}>
        <AppTooltip
          label={payment.type}
          disabled={!isOverflowing}
          position='bottom'
          offset={8}
          arrowPosition='center'>
          <p className={styles.root_title}>{typeSlice}</p>
        </AppTooltip>
      </div>
      <p className={styles.root_title} style={{ textAlign: 'end' }}>
        {addSpaceNumber(payment.amount)}
      </p>
      <div>
        <div style={{ padding: '0 16px' }}>
          <BeneficiariesTabBtn
            classNameStyles={styles.statusBlock}
            oldStyle
            bg={payment.status?.color_bg}
            color={payment.status?.color_text}
            title={payment.status.text}
          />
        </div>
        <p className={styles.root_subTitle}>
          <IconSvg /> {getFotmattedDateCreated(payment.tochka_updated_at)}. назад
        </p>
      </div>
      <p>{payment.identified ? <IconDone /> : <IconError />}</p>
    </div>
  );
};
